import { render, staticRenderFns } from "./rightList.vue?vue&type=template&id=27cebfaf&scoped=true&"
import script from "./rightList.vue?vue&type=script&lang=js&"
export * from "./rightList.vue?vue&type=script&lang=js&"
import style0 from "./rightList.vue?vue&type=style&index=0&id=27cebfaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cebfaf",
  null
  
)

export default component.exports